import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602301b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "请选择要批改的保单", -1))
const _hoisted_4 = { class: "list-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "van-hairline--surround list-item" }
const _hoisted_7 = { class: "top-box" }
const _hoisted_8 = { class: "top" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "left-title" }
const _hoisted_11 = {
  key: 0,
  class: "left-middle-text fix-margin-t-16 serial-number-text"
}
const _hoisted_12 = {
  key: 1,
  class: "left-middle-text fix-margin-t-16"
}
const _hoisted_13 = {
  key: 2,
  class: "left-middle-text"
}
const _hoisted_14 = {
  key: 3,
  class: "left-middle-text fix-margin-b-16"
}
const _hoisted_15 = {
  key: 4,
  class: "left-bottom-text"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_18 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}
const _hoisted_19 = { class: "footer-left nongfu-checkbox-wrap" }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Button, Checkbox } from 'vant'
import dayjs from 'dayjs'
import { ClientJijiaInsuranceListItem } from '@/types/insurance'
import {
  batchPinganCorrectInformation,
  getPingAnInsuranceList,
} from '@/apis/three-liability-insurance'
import { ChangePingan2024ThirdPartyLiabilityInformationParams } from '@/types/three-liability-insurance'
import { insuranceTypeItem, serviceItem, tagSatus, serviceTagSatusItem } from '@/types/three-liability-insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { showToastLoading, clearToast, showToastSuccess, showToastFail } from '@/utils/tools'
import { getThirdPartyInsuranceStatusSortWeight } from '@/views/insurance/common'
import AppHeader from '@/components/Header.vue'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import InsuredObjectForm, { type PinganCorrectPolicyItem } from './pingan2024-insured-person.vue'

type SelectRenderItem = {
  id: number
  pageTitle: string
  serial_number: string
  status: number
  begin_date: string
  end_date: string
  text: string
  background: string
  policy_no: string
  insurant_name: string
  insurance_type: number
  insurance_type_company: string
  eq_sn: string
  phone_number: string
  personnel_type: ClientJijiaInsuranceListItem['personnel_type']
  product_info: ClientJijiaInsuranceListItem['product_info']
  operation: ClientJijiaInsuranceListItem['operation']
  policy_start_at: string
  policy_end_at: string
  status_desc: string
  tagClass: string
  activate_at: string
  order_type: string
  apply_policy_no: string
  created_at: string
  premium: string
  amount: string
  use_amount: string
  remain_amount: string
  eq_name: string
  eq_logo: string
  eq_model: string
  eq_model_name: string
  is_applets: ClientJijiaInsuranceListItem['is_applets']
}


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'third-party-correct-select',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const LIST_ITEM_ID_BASE = 900000

const insuranceTypeMap: insuranceTypeItem = {
  '2': '中国平安财产保险股份有限公司',
  '5': '中国人民财产保险股份有限公司',
}

const statusMap: tagSatus<serviceTagSatusItem> = {
  0: {
    text: '无服务',
    background: 'rgba(0,0,0,0.22)',
  },
  1: {
    text: '保障中',
    background: 'rgba(57, 181, 74, 1)',
  },
  2: {
    text: '已到期',
    background: 'rgba(247,152,28,1)',
  },
  3: {
    text: '待生效',
    background: 'rgba(247,152,28,1)',
  },
}

const $route = useRoute()
const $router = useRouter()
const sn = ($route.query.sn || $route.query.eq_sn) as string
const loading = ref(false)
const selectableList = ref<SelectRenderItem[]>([])
const selectedIds = ref<number[]>([])
const showCorrectPopup = ref(false)
const correctPopupPolicyItems = ref<PinganCorrectPolicyItem[]>([])

const selectedItems = computed(() => {
  return selectableList.value.filter((item) => selectedIds.value.includes(item.id))
})

const correctPopupPolicyKey = computed(() => {
  return correctPopupPolicyItems.value.map((item) => item.policy_no).join('_')
})

const isAllSelected = computed({
  get() {
    return (
      selectableList.value.length > 0 &&
      selectableList.value.every((item) => selectedIds.value.includes(item.id))
    )
  },
  set(checked: boolean) {
    selectedIds.value = checked ? selectableList.value.map((item) => item.id) : []
  },
})

function canThirdPartyCorrect(data: serviceItem) {
  return data.status === 1 || data.status === 3
}

function mapThirdPartyInsuranceToListItem(
  data: serviceItem,
  eqSn: string,
  index: number
): SelectRenderItem {
  const status = data.status ?? 0
  const statusInfo = statusMap[status] || statusMap[0]
  const insuranceType = data.insurance_type ?? 2
  const personnelType = String(data.insurant_type ?? '1')
  const beginDate = data.policy_begin_date
    ? dayjs(Number(data.policy_begin_date) * 1000).format('YYYY-MM-DD HH:mm')
    : ''
  const endDate = data.policy_end_date
    ? dayjs(Number(data.policy_end_date) * 1000).format('YYYY-MM-DD HH:mm')
    : ''
  return {
    id: LIST_ITEM_ID_BASE + index,
    pageTitle: data.product_name || '设备第三者责任险',
    serial_number: data.serial_number || eqSn,
    status,
    begin_date: beginDate,
    end_date: endDate,
    text: statusInfo.text,
    background: statusInfo.background,
    policy_no: data.policy_no,
    insurant_name: data.insurant_name,
    insurance_type: insuranceType,
    insurance_type_company: insuranceTypeMap[insuranceType + ''] || '',
    eq_sn: data.serial_number || eqSn,
    phone_number: data.insurant_phone_no || '',
    personnel_type: personnelType as ClientJijiaInsuranceListItem['personnel_type'],
    policy_start_at: beginDate,
    policy_end_at: endDate,
    status_desc: statusInfo.text,
    tagClass: '',
    activate_at: '',
    order_type: '',
    apply_policy_no: '',
    created_at: '',
    premium: '',
    amount: '',
    use_amount: '',
    remain_amount: '',
    eq_name: '',
    eq_logo: '',
    eq_model: '',
    eq_model_name: '',
    is_applets: 2,
    product_info: {
      pro_name: '',
      pro_type: 0,
      pro_type_text: '',
      pro_sub_type: 0,
      pro_sub_type_text: '',
      pro_version: '',
      pro_version_text: '',
      product_name: data.product_name || '设备第三者责任险',
    },
    operation: {
      operation_status: 0,
      message: '',
      download_status: 0,
      correct_status: 2,
      correct_message: '',
    },
  }
}

async function fetchPolicies() {
  const list = await getPingAnInsuranceList({ sn })
  return list
    .filter(canThirdPartyCorrect)
    .sort(
      (a, b) =>
        getThirdPartyInsuranceStatusSortWeight(a.status) -
        getThirdPartyInsuranceStatusSortWeight(b.status)
    )
    .map((item, index) => mapThirdPartyInsuranceToListItem(item, sn, index))
}

async function initPageData() {
  loading.value = true
  showToastLoading()
  try {
    selectableList.value = await fetchPolicies()
    selectedIds.value = []
  } catch (error) {
    commonErrorHandle(error)
  } finally {
    loading.value = false
    clearToast()
  }
}

function toggleSelect(id: number, checked?: boolean) {
  const isChecked = typeof checked === 'boolean' ? checked : !selectedIds.value.includes(id)
  if (isChecked) {
    if (!selectedIds.value.includes(id)) {
      selectedIds.value = [...selectedIds.value, id]
    }
    return
  }
  selectedIds.value = selectedIds.value.filter((itemId) => itemId !== id)
}

function confirmHandle() {
  if (selectedIds.value.length === 0) {
    return
  }
  correctPopupPolicyItems.value = selectedItems.value.map((item) => ({
    policy_no: item.policy_no,
    phone: item.phone_number,
  }))
  showCorrectPopup.value = true
}

async function handleBatchCorrectSubmit(
  list: ChangePingan2024ThirdPartyLiabilityInformationParams[]
) {
  showToastLoading()
  try {
    const data = await batchPinganCorrectInformation(list)
    if (data?.status === 400) {
      showToastFail(data.message)
      return
    }
    showToastSuccess('批改成功')
    onCorrectSuccess()
  } catch (error) {
    commonErrorHandle(error)
  } finally {
    clearToast()
  }
}

function onCorrectSuccess() {
  showCorrectPopup.value = false
  if (sn) {
    sessionStorage.setItem('thirdPartyLiabilityDetailNeedRefresh', sn)
  }
  $router.back()
}

onMounted(() => {
  void initPageData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "批改被保人" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "list-row",
              onClick: ($event: any) => (toggleSelect(item.id))
            }, [
              _createElementVNode("div", {
                class: "checkbox-wrap nongfu-checkbox-wrap",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_unref(Checkbox), {
                  "model-value": selectedIds.value.includes(item.id),
                  "onUpdate:modelValue": (checked) => toggleSelect(item.id, checked)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.pageTitle), 1),
                      (item.status !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "设备序列号：" + _toDisplayString(item.serial_number), 1))
                        : _createCommentVNode("", true),
                      (item.status !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "被保人：" + _toDisplayString(item.insurant_name), 1))
                        : _createCommentVNode("", true),
                      (item.status !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "生效时间：" + _toDisplayString(item.begin_date), 1))
                        : _createCommentVNode("", true),
                      (item.status !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "到期时间：" + _toDisplayString(item.end_date), 1))
                        : _createCommentVNode("", true),
                      (item.status !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createTextVNode(" NO. " + _toDisplayString(item.policy_no), 1),
                            _hoisted_16,
                            _createTextVNode("由" + _toDisplayString(item.insurance_type_company) + "承保 ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: "tag",
                      style: _normalizeStyle({ background: item.background })
                    }, _toDisplayString(item.text), 5)
                  ])
                ])
              ])
            ], 8, _hoisted_5))
          }), 128)),
          (!loading.value && selectableList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无可批改保单"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (selectableList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_unref(Checkbox), {
              modelValue: _unref(isAllSelected),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isAllSelected) ? (isAllSelected).value = $event : null))
            }, {
              default: _withCtx(() => [
                _createTextVNode("全选")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            class: "confirm-button xa-vant-button",
            disabled: selectedIds.value.length === 0,
            onClick: confirmHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(PopupCommonWrap, {
      show: showCorrectPopup.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showCorrectPopup).value = $event)),
      title: "批改被保人"
    }, {
      default: _withCtx(() => [
        (showCorrectPopup.value && correctPopupPolicyItems.value.length)
          ? (_openBlock(), _createBlock(InsuredObjectForm, {
              key: _unref(correctPopupPolicyKey),
              policyItems: correctPopupPolicyItems.value,
              useExternalSubmit: "",
              onSubmit: handleBatchCorrectSubmit
            }, null, 8, ["policyItems"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})